<template>
	<h1>Kalkulator</h1>
	<div class="inputs">
		<tariff></tariff>
		<cartype></cartype>
		<timerange></timerange>
		<distance></distance>
	</div>
	<results></results>
</template>

<script>
import Tariff from './components/Tariff.vue';
import Cartype from './components/Cartype.vue';
import Timerange from './components/Timerange.vue';
import Distance from './components/Distance.vue'
import Results from './components/Results.vue';

export default {
	components: {
		Tariff,
		Cartype,
		Timerange,
		Distance,
		Results
	},
	mounted() {
		this.$store.dispatch('fillCartypes');
	}
}
</script>

<style lang="scss">

*, *:before, *:after {
	box-sizing: border-box;
}

html {
	font-family: $fontfamily;
	font-size: 1.0625rem;
	box-sizing: border-box;
}
body {
	margin: 0;
}
#app {
	margin: 10px auto;
	width: 375px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: $color-text;
	border-radius: 15px;
	overflow: hidden;
	background-color: #fff;
	box-shadow: 2px 5px 15px rgba(0,0,0,0.5);
	@media screen and (max-width: 375px) {
		margin-top: 0;
		width: 100vw;
		border-radius: 0;
		box-shadow: none;
	}
}
h1 {
	background-color: $color-header-bg;
	color: #fff;
	margin: 0 0 10px;
	padding: 10px;
	text-align: center;
	font-size: 1.235rem;
}

.inputs {
	width: 315px;
	margin: 30px auto 10px;
}
.field {
	margin: 20px auto;
}
label {
	display: block;
	margin: 0 15px 5px;
	color: $color-label;
	font-size: .765rem;
}
input, select {
	width: 100%;
	border: 1px solid $color-input-border;
	border-radius: 15px;
	padding: 10px 15px 8px;
	font-family: $fontfamily;
	font-weight: bold;
	font-style: normal;
	font-size: 1rem;
	color: $color-input-text;
	background-color: #fff;
	appearance: unset;
}
option {
	font: caption;
	color: black;
}
input:focus, select:focus {
	border-color: $color-input-border-focus;
	outline: none;
}
.field > select {
	background-image: $icon-arrow;
	background-repeat: no-repeat;
	background-position: 97% 3px;
}
</style>
